import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaGithub } from 'react-icons/fa';

const socialLinks = [
  { icon: <FaFacebook />, href: 'https://www.facebook.com/TechVelly2k25' },
  { icon: <FaTwitter />, href: 'https://x.com/Techvelly2025' },
  { icon: <FaLinkedin />, href: 'https://www.linkedin.com/company/techvelly' },
  { icon: <FaGithub />, href: 'https://github.com/mhfaisalbd' },
];

const Footer = () => {
  const sections = {
    'Company': [
      { name: 'About Us', path: '/company' },
      { name: 'Case Studies', path: '/case-studies' },
      { name: 'Blog', path: '/blog' },
      { name: 'Terms & Conditions', path: '/terms-and-conditions' },
      { name: 'Privacy Policy', path: '/privacy-policy' },
      { name: 'Contact Us', path: 'mailto:info@techvelly.com' },
    ],
    'Services': [
      { name: 'AI Solutions', path: '/ai-solutions' },
      { name: 'Custom Development', path: '/services' },
      { name: 'Edutech', path: '/edutech' },

    ],
    'Connect': [
      
    ],
  };

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-1">
            <h2 className="text-2xl font-bold text-brand-dark">TechVelly</h2>
            <p className="text-gray-500 mt-2">Innovative IT Solutions.</p>
          </div>
          
          {/* Links Columns */}
          {Object.keys(sections).map(title => (
            <div key={title}>
              <h3 className="font-semibold text-brand-dark mb-4">{title}</h3>
              <ul className="space-y-2">
                {sections[title].map(link => (
                  <li key={link.name}>
                    {link.external ? (
                      <a href={link.path} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-brand-blue transition-colors duration-200">
                        {link.name}
                      </a>
                    ) : (
                      <Link to={link.path} className="text-gray-600 hover:text-brand-blue transition-colors duration-200">
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
                {title === 'Connect' && (
                  <>
                    <li className="mb-2 flex items-center"><a href="mailto:info@techvelly.com" className="text-gray-600 hover:text-brand-blue transition-colors duration-200">info@techvelly.com</a></li>
                    <li className="mb-2 flex items-center"> <a href="mailto:sales@techvelly.com" className="text-gray-600 hover:text-brand-blue transition-colors duration-200">sales@techvelly.com</a></li>
                    <li className="mb-8 flex items-center"><a href='tel:+8809611609244' className="text-gray-600 hover:text-brand-blue transition-colors duration-200">+8809611609244</a> </li>
                    <div className="flex space-x-4">
                      {socialLinks.map((link, index) => (
                        <a 
                        target="_blank" 
                        rel="noopener noreferrer"
                        key={index} href={link.href} className="text-gray-600 hover:text-blue-500 text-2xl">{link.icon}</a>
                      ))}
                    </div>
                  </>
                )}
              </ul>
              
            </div>
          ))}
          
        </div>
        
        
        <div className="border-t border-gray-200 mt-12 pt-8 text-center">
          <p className="text-gray-500">&copy; {new Date().getFullYear()} TechVelly. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
